// Top-level draw: clears the viewport, sets the field transform, and composites
// the world, HUD, and phase screens.

import type { GameState, Vec2 } from '../core';
import { FIELD_W, FIELD_H } from '../core';
import { applyFieldTransform, type Viewport } from '../shell/canvas';
import { PALETTE, paletteForWave } from './palette';
import { drawWorld } from './drawWorld';
import { drawHud } from './drawHud';
import { drawScreens } from './drawScreens';

export function render(
  ctx: CanvasRenderingContext2D,
  state: GameState,
  vp: Viewport,
  pointer: Vec2,
): void {
  // Clear the whole viewport (including letterbox bars) in device pixels.
  ctx.setTransform(vp.dpr, 0, 0, vp.dpr, 0, 0);
  ctx.fillStyle = PALETTE.void;
  ctx.fillRect(0, 0, vp.cssW, vp.cssH);

  applyFieldTransform(ctx, vp);
  ctx.save();
  ctx.beginPath();
  ctx.rect(0, 0, FIELD_W, FIELD_H);
  ctx.clip();

  drawWorld(ctx, state, pointer, paletteForWave(state.wave));
  drawHud(ctx, state);
  drawScreens(ctx, state);

  ctx.restore();
}
